<script setup>

import {ref} from "vue";

const props = defineProps({
    color: {
        type: String,
        required: true
    }
})
const graphExportType = ref("save")
const emit = defineEmits(['on-export-txs-click', 'on-export-addrs-click'])

</script>

<template>
    <v-menu
        :close-on-content-click="false"
        bottom
        offset-x
    >
        <template v-slot:activator="{ on: menuOn, attrs }">
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn
                        :color="color + ' darken-1'"
                        dark
                        fab
                        small
                        v-bind="$attrs"
                        v-on="{...on,...$listeners,...menuOn}"
                    >
                        <v-icon>mdi-export</v-icon>
                    </v-btn>
                </template>
                <span>Export Addresses or Transactions</span>
            </v-tooltip>
        </template>
        <v-list>
            <v-subheader class="ml-1" style="height: 24px">Export options</v-subheader>
            <div class="width100 d-flex align-center justify-center mb-1">
                <v-btn-toggle color="info" v-model="graphExportType" dense>
                    <v-btn value="show" x-small>
                        Show
                    </v-btn>
                    <v-btn value="save" x-small>
                        Save
                    </v-btn>
                </v-btn-toggle>
            </div>
            <v-divider class="width100"/>
            <v-list-item @click="emit('on-export-addrs-click',graphExportType)">
                Addresses
            </v-list-item>
            <v-list-item @click="emit('on-export-txs-click',graphExportType)">
                Transactions
            </v-list-item>
        </v-list>
    </v-menu>
</template>
